import Types from "./Types";

export const setUserAction = (isLoading) => ({
  type: Types.SET_USER_IS_LOADING,
  payload: isLoading,
});

export const getUserDataRequest = () => ({
  type: Types.GET_USER_DATA_REQUEST,
});

export const getUserDataSuccess = (data) => ({
  type: Types.GET_USER_DATA_SUCCESS,
  payload: data,
});

export const getUserDataFail = () => ({
  type: Types.GET_USER_DATA_FAIL,
});

export const getNotificationsRequest = (payload) => ({
  type: Types.GET_NOTIFICATIONS_REQUEST,
  payload,
});

export const getNotificationsSuccess = (data) => ({
  type: Types.GET_NOTIFICATIONS_SUCCESS,
  payload: data,
});

export const getNotificationsFail = () => ({
  type: Types.GET_NOTIFICATIONS_FAIL,
});

export const getUserGroupsRequest = (payload) => ({
  type: Types.GET_USER_GROUPS_REQUEST,
  payload,
});

export const getUserGroupsSuccess = (data) => ({
  type: Types.GET_USER_GROUPS_SUCCESS,
  payload: data,
});

export const getUserGroupsFail = () => ({
  type: Types.GET_USER_GROUPS_FAIL,
});
